// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-from {\n    margin-top: 20px;\n}\n.header {\n    height: 56px;\n    line-height: 56px;\n    padding: 0 24px;\n    border-bottom: 1px solid #f5f5f5;\n}\n.product {\n    margin: 0 24px;\n    margin-bottom: 24px;\n}\n.firstTitle {\n    font-size: 16px;\n    color: #262626;\n    font-weight: 700;\n}\n.secondTitle {\n    font-size: 14px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
